module.exports = __webpack_public_path__ + "static/media/1.login.06d0a3ab.jpg";